import axios from 'axios';
import apiService from '../apiService';

export default async function deleteExpressionDetectionsByEvent(eventId = '', system = '') {
  try {
    let _token = await apiService.getUserToken();

    let _request = {
      url: `${apiService.getUrl().faceRecognition}expressionDetection/deleteExpressionDetectionsByEvent`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `BEARER ${_token}`,
      },
      data: {
        eventId: eventId,
        system: system,
      }
    }
    const _ret = await axios(_request);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return;
  } catch (error) {
    console.log('Error saveExpressionDetection', error);
    throw error;
  }
}
